export default __webpack_public_path__ + "static/media/fish.1143bce1.png";